import { frontendURL } from '../../../helper/URLHelper';
import MetaCampaignTracking from './MetaCampaignTracking.vue';

const PERMISSIONS = ['administrator', 'agent'];

export const routes = [
  {
    path: frontendURL('accounts/:accountId/campaign-tracking'),
    name: 'campaign_tracking_view',
    meta: {
      permissions: PERMISSIONS,
    },
    component: MetaCampaignTracking,
  },
];
